module.exports = __webpack_public_path__ + "static/img/laser.965082a1.png";